import SearchCheckbox from "./SearchCheckbox";

export default SearchCheckbox;
